module.exports = __webpack_public_path__ + "images/help/logo-roadmap-d7474ed58026069084a19a0869ea24b6.png";